import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import { Button, ButtonVariantOption } from "@/components/Button";
import { PagePaper } from "@/components/Paper";
import { PageTitle } from "@/components/Title";

// 登記取得専用画面の全画面ステート表示部品（レイアウト枠 / エラー / ローディング）。

/**
 * ページ共通レイアウト（PagePaper + タイトルヘッダー）。
 * エラー/ローディング/通常表示すべてを同じ骨格でラップし、状態遷移時のガタつきを抑える。
 */
export const PropertyCodeAcquisitionPageLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <PagePaper>
    {/* アイコン・タイトルは他画面〔不動産登記モニタリング〕と統一する。 */}
    <Box sx={{ display: "flex", mb: 3 }}>
      <MonitorHeartIcon sx={{ mr: 1 }} fontSize="large" />
      <PageTitle>不動産登記取得履歴</PageTitle>
    </Box>
    {children}
  </PagePaper>
);

/** 全画面エラー表示（視覚のみに依存しないよう role="alert" を付与）。再読み込みボタンは任意。 */
export const PropertyCodeAcquisitionErrorView: React.FC<{
  message: string;
  onReload?: () => void;
}> = ({ message, onReload }) => (
  <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 8 }}>
    <Typography role="alert" color="error">
      {message}
    </Typography>
    {onReload != null && (
      <Button
        variant={ButtonVariantOption.Outlined}
        label="再読み込み"
        onClick={onReload}
      />
    )}
  </Stack>
);

/** 全画面ローディング表示。 */
export const PropertyCodeAcquisitionLoadingView: React.FC = () => (
  <Stack
    role="status"
    alignItems="center"
    justifyContent="center"
    sx={{ py: 8 }}
    aria-busy
  >
    <CircularProgress aria-label="読み込み中" />
    <Typography sx={{ mt: 2 }}>読み込み中…</Typography>
  </Stack>
);
